import React, { useEffect, useState } from "react";
import { SortableContext, verticalListSortingStrategy, useSortable } from "@dnd-kit/sortable";
import { BookingContentName, BookingContentWrap, MyBookingWrapper } from "../MyBooking/styled/DesStyled";
import {
	StyledSortableItem,
	StyledSortableItemButton,
	StyledSortableItemButtonCheck,
	StyledSortableItemDivWrap,
	StyledSortableItemWrap,
} from "./styled/PaymentNumber";
import usePaymentMethod from "./hook/getPaymentChannel";
import { PaymentMethod } from "../../../models/User";
import useUpdatePaymentMethod from "./hook/useUpdateIndex";
import useUpdatePaymentMethodStatus from "./hook/useUpdateStatus";
import { DndContext, PointerSensor, KeyboardSensor, useSensor, useSensors, TouchSensor } from "@dnd-kit/core";
import PermissionGate from "../../controls/auth/PermissionGate";

export default function PaymentChannelNumberPage() {
	const [loading, setLoading] = useState(false);
	const { paymentMethod, reload } = usePaymentMethod();
	const { doUpdate } = useUpdatePaymentMethod({ setLoading: setLoading });

	const [channels, setChannels] = useState(paymentMethod);

	const handleDragEnd = (event: any) => {
		const { active, over } = event;
		if (active.id !== over?.id) {
			const oldIndex = channels.findIndex((channel) => channel.id === active.id);
			const newIndex = channels.findIndex((channel) => channel.id === over?.id);

			const updatedChannels = [...channels];
			const [removed] = updatedChannels.splice(oldIndex, 1);
			updatedChannels.splice(newIndex, 0, removed);

			setChannels(updatedChannels);
		}
	};

	useEffect(() => {
		if (paymentMethod?.length) {
			setChannels(paymentMethod);
		}
	}, [paymentMethod]);

	const sensors = useSensors(useSensor(PointerSensor), useSensor(TouchSensor), useSensor(KeyboardSensor));

	return (
		<MyBookingWrapper>
			<BookingContentWrap>
				<StyledSortableItemDivWrap>
					<BookingContentName>Cấu hình kênh thanh toán</BookingContentName>
					<PermissionGate permission="settings.manage">
						<StyledSortableItemButton onClick={() => doUpdate(channels.map((ch) => ch.id))}>
							{loading ? "Đang lưu" : "Lưu cấu hình"}
						</StyledSortableItemButton>
					</PermissionGate>
				</StyledSortableItemDivWrap>

				<DndContext
					sensors={sensors}
					onDragEnd={handleDragEnd}>
					<SortableContext
						items={channels.map((ch) => ch.id)}
						strategy={verticalListSortingStrategy}>
						{channels.map((channel) => (
							<SortableItem
								key={channel.id}
								id={channel.id}
								name={channel.name}
								status={channel.status}
								reload={reload}
							/>
						))}
					</SortableContext>
				</DndContext>
			</BookingContentWrap>
		</MyBookingWrapper>
	);
}

export const SortableItem = (props: { id: any; name: any; status: any; reload: () => void }) => {
	const [loading, setLoading] = useState(false);

	const { attributes, listeners, setNodeRef, isDragging } = useSortable({ id: props.id });
	const { doUpdate } = useUpdatePaymentMethodStatus({ setLoading: setLoading, reload: props.reload });
	return (
		<StyledSortableItemWrap>
			<StyledSortableItem
				ref={setNodeRef}
				{...attributes}
				{...listeners}
				isDragging={isDragging}>
				<span className="font-medium">{props.name}</span>
			</StyledSortableItem>
			<PermissionGate permission="settings.manage">
				<StyledSortableItemButtonCheck
					onClick={(e) => {
						doUpdate(props.id, props.status === 1 ? 2 : 1);
					}}>
					{loading ? "..." : props.status === 1 ? "Ẩn" : "Hiện"}
				</StyledSortableItemButtonCheck>
			</PermissionGate>
		</StyledSortableItemWrap>
	);
};
